import React, { FC, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { SingleFormObjType } from "DataTypes/Form";
import { CommonStyle, ControlledForm, ControlledTable } from "Components";
import {
  actionArr,
  FormDataObj,
  PreApprovTableDataType,
  TableCol,
  TableData
} from "./Data";
import CommonFormatter from "Utils/Common.Formatter";
import { RouteUrls } from "Constant/RouteUrls";
import { HeaderInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { TableLayout } from "Layouts";
import CstmBtn from "Components/CstmBtn";
import { useNavigate } from "react-router-dom";

const PreApprovedPlan: FC = () => {
  const navigate = useNavigate();
  const { organization }: HeaderInitialStateType = useSelector(
    (state: any) => state?.header
  );
  const [formObj, setFormObj] = useState<SingleFormObjType>(FormDataObj);

  useEffect(() => {
    CommonFormatter.HandleNavArr({
      id: "upload patient",
      label: `${organization.name}'s Pre Approved Plans`,
      path: `/${RouteUrls.hs}/${RouteUrls.organization}` +
        `/${RouteUrls.preApprovedPlan}`,
      level: 2,
      link: RouteUrls.preApprovedPlan,
      navType: "org",
    });
  }, []);

  const handleEditPreApprovedPlan: (
    data: PreApprovTableDataType
  ) => void = (data) => {
    navigate(`./${data.id}/${RouteUrls.plan}`);
  }

  const TblBodyJSX = (
    <ControlledTable.TblBody
      tableColumn={() => TableCol()}
      tableRow={TableData}
      tableAction={(data: PreApprovTableDataType) =>
        actionArr(
          () => handleEditPreApprovedPlan(data),
        )
      }
    />
  );

  return (
    <Box height="91%" sx={{ ...CommonStyle.sxWhiteBox, overflow: "auto" }}>
      <Box sx={{ p: 2 }}>
        <Box display="flex" mb={2} alignItems={"end"}>
          <Box width="30%" mr={2}>
            <ControlledForm.SingleApi
              {...formObj}
              onClick={async (val) => setFormObj({ ...formObj, dropVal: val })}
            />
          </Box>
          <CstmBtn label="Create Plan" onClick={() => {
            navigate(`./${formObj.dropVal}/${RouteUrls.plan}`);
          }} />
        </Box>
        <TableLayout
          tblBody={TblBodyJSX}
          tblHead={ControlledTable.TblHead(TableCol())}
        />
      </Box>
    </Box>
  );
};
export default PreApprovedPlan;
